﻿import * as React from 'react';
import { Badge } from '~/common/components/ui/badge.tsx';
import { cn } from '~/common/utils/styleUtil.ts';
import { useTranslation } from 'react-i18next';

type PriceBadgeType = 'gross' | 'hit' | 'new';
type Size = 'sm' | 'md';

export interface PriceBadgeProps extends React.ComponentProps<typeof Badge> {
  type: PriceBadgeType;
  size?: Size;
}

const typeClasses: Record<PriceBadgeType, string> = {
  gross: 'bg-yellow-400 text-black hover:bg-yellow-400',
  hit: 'bg-primary text-white hover:bg-primary',
  new: 'bg-cyan-500 text-white hover:bg-cyan-500'
};

const sizeClasses: Record<Size, string> = {
  sm: 'text-[10px] leading-none px-2 py-0.5 rounded-[3px]',
  md: 'text-xs leading-none px-3 py-1 rounded-[3px]' // nahe am Screenshot
};

const defaultLabels: Record<PriceBadgeType, string> = {
  gross: 'GROSSMENGENPREIS',
  hit: 'HIT',
  new: 'NEW'
};

export function PriceBadge({ type, size = 'md', className, children, ...props }: Readonly<PriceBadgeProps>) {
  const { t } = useTranslation();
  return (
    <Badge className={cn(typeClasses[type], sizeClasses[size], className)} {...props}>
      {children ?? t(defaultLabels[type] as any)}
    </Badge>
  );
}
